module.exports = __webpack_public_path__ + "static/media/add.d7dc12f1.svg";